import * as actions from './actions'

const defaultCurrentUserState = {
  isFetching: false,
  fetchAttempted: false,
  fetchError: '',
  data: {}
}

const currentUser = (state = defaultCurrentUserState, action) => {
  switch(action.type) {
    case actions.REQUEST_USER_DATA:
      return Object.assign({}, state, { isFetching: true, fetchAttempted: true })
    case actions.RECEIVE_USER_DATA:
      return Object.assign({}, state, { data: action.data, isFetching: false })
    case actions.RECEIVE_USER_DATA_FAILURE:
      return Object.assign({}, state, { fetchError: action.error, isFetching: false })
    default:
      return state
  }
}

export default currentUser
